import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = { class: "_mb-6 gfu-bt--b1" }
const _hoisted_2 = ["href", "title"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_title = _resolveComponent("base-title")
  const _component_base_image = _resolveComponent("base-image")
  const _component_base_carousel_navigation = _resolveComponent("base-carousel-navigation")
  const _component_base_carousel = _resolveComponent("base-carousel")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_title, {
      as: "h3",
      level: "h2"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.Resources.PledgeManager.SectionPartnersTitle), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.Resources.PledgeManager.SectionPartnersDescription), 1 /* TEXT */),
    _createVNode(_component_box, null, {
      default: _withCtx(() => [
        _createVNode(_component_base_carousel, {
          autoplay: true,
          items: $props.items,
          class: "gfu-base-carousel",
          onChange: $options.onChange
        }, {
          view: _withCtx(() => [
            _createVNode(_TransitionGroup, {
              name: $options.transitionName,
              tag: "div",
              class: "_flex _ov-h gfu-base-carousel-wrapper"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.slides, (slide) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: slide.name,
                    class: "gfu-1of2 gfu-1of4--m _px-6 _tac"
                  }, [
                    _createElementVNode("a", {
                      href: slide.url,
                      target: "_blank",
                      title: slide.name,
                      class: "gfu-embed gfu-embed--1x1",
                      rel: "noopener noreferrer"
                    }, [
                      _createVNode(_component_base_image, {
                        class: "gfu-embed__item _pa-4",
                        src: slide.imageUrl,
                        alt: slide.name,
                        width: "120",
                        height: "120",
                        loading: "lazy"
                      }, null, 8 /* PROPS */, ["src", "alt"])
                    ], 8 /* PROPS */, _hoisted_2)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["name"])
          ]),
          nav: _withCtx(({ onNext, onPrev }) => [
            _createVNode(_component_base_carousel_navigation, {
              type: "prev",
              icon: "angle-left",
              class: "gfu-partners-slider-nav--prev",
              onClick: onPrev
            }, null, 8 /* PROPS */, ["onClick"]),
            _createVNode(_component_base_carousel_navigation, {
              type: "next",
              icon: "angle-right",
              class: "gfu-partners-slider-nav--next",
              onClick: onNext
            }, null, 8 /* PROPS */, ["onClick"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["items", "onChange"])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}